/* eslint-disable @typescript-eslint/camelcase */
import { PartnerFormFields } from 'modules/partners/interfaces';

export const initial: PartnerFormFields = {
  company_uuid: '',
  company_name: '',
  partner_status: 'active',
  name: '',
  alias: '',
  use_email: false,
  use_plugin: false,
  enforce_env_license_limit: true,
  use_cloud: [],
  frontend: {
    language: 'pt-br',
    logo: '',
    use_browser_language: false,
    enable_new_interface: true,
    migration: {
      enabled: false,
      deadline: null,
    },
  },
  plugin: {
    url_plugin: '',
    url_return: '',
  },
  email: {
    from: '',
    domain: '',
    subject: '',
  },
  cloud_providers: {
    aws: {
      role_arn: '',
      owner_id: '',
      external_id: '',
      token: '',
    },
    oci: {
      compartment_id: '',
      profile_name: 'DEFAULT',
    },
  },
  active_directory: {
    ldap_type: 'internal',
    ldap_server: '',
    ldap_server_backup: '',
    admin_bind_pass: '',
    admin_bind_dn: '',
    base_dn: '',
    ad_domain: '',
    ad_password_salt_enabled: true,
    can_external_ad_change_password: false,
  },
  allow_sso_configuration: false,
  allow_duo_configuration: false,
  recaptcha: {
    enabled: true,
    reason: '',
    changed_at: '',
    changed_by: {
      first_name: '',
      last_name: '',
      email: '',
    },
  },
  show_instances_list: false,
};

export const initialQuery = {
  offset: 0,
  limit: 25,
  search: '',
};

export const mapLabels = {
  aws: 'Amazon Web Service',
  gcp: 'Google Cloud Platform',
  oci: 'Oracle Cloud Infrastructure',
};
